/**
 * Currency formatting utility
 * Supports multiple currencies (USD, MVR, CHN)
 */

// Currency symbols mapping
const CURRENCY_SYMBOLS = {
  'USD': '$',
  'MVR': 'ރ. ',
  'CHN': '¥'
};

/** Format a number with commas and 2 decimal places */
export const fmtNum = (n) => {
  const num = typeof n === 'string' ? parseFloat(n) : (n || 0);
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatCurrency = (amount, currency = 'USD') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    const symbol = CURRENCY_SYMBOLS[currency] || '$';
    if (currency === 'MVR') {
      return `0.00${symbol}`;
    }
    return `${symbol}0.00`;
  }
  
  const formatted = fmtNum(amount);
  const symbol = CURRENCY_SYMBOLS[currency] || '$';
  
  // MVR symbol goes after the number (Maldivian style)
  if (currency === 'MVR') {
    return `${formatted} ${symbol}`;
  }
  
  // Other currencies: symbol before number
  return `${symbol}${formatted}`;
};

export const getCurrencySymbol = (currency = 'USD') => {
  return CURRENCY_SYMBOLS[currency] || '$';
};

export const CURRENCY_SYMBOL = '$';
